import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IParsedTreesState = { };

const designTypeReducer = (
  state: types.IParsedTreesState = defaultState, 
  action: IAction | types.ISetParsedTreeAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_PARSEDTREE: {
      return {...state, parsedTrees: (action as types.ISetParsedTreesAction).parsedTrees};
    }
    case actionTypes.SET_PARSEDTREE_INFO: {
      return {...state, parsedTree: (action as types.ISetParsedTreeAction).parsedTree};
    }
    case actionTypes.ADD_SUCCESS_PARSEDTREE: {
      return {...state, response: (action as types.IServerSuccessAction).response};
    }
    case actionTypes.SET_SEARCH_PARSEDTREE: {
      return {...state, searches: (action as types.ISetSearchAction).searches};
    }
    case actionTypes.SET_COUNTER_PARSEDTREE: {
      return {...state, counter: (action as types.ISetCounterAction).counter};
    }
    case actionTypes.SET_UPDATE_PARSEDTREE_ELEMENTS: {
      return {...state, updatedElementsResponse: (action as types.ISetUpdateParsedTreeElements).updatedElementsResponse};
    }
    case actionTypes.SET_UPDATE_PARSEDTREE_FIELD: {
      return {...state, updatedFieldResponse: (action as types.ISetUpdateParsedTreeField).updatedFieldResponse};
    }
    case actionTypes.SET_UPDATE_PARSEDTREE_FIELDTAGS: {
      return {...state, updatedFieldTagsResponse: (action as types.ISetUpdateParsedTreeFieldTags).updatedFieldTagsResponse};
    }
    case actionTypes.SET_UPDATE_PARSEDTREE_FIELDSTAGS: {
      return {...state, updatedFieldsTagsResponse: (action as types.ISetUpdateParsedTreeFieldsTags).updatedFieldsTagsResponse};
    }
    case actionTypes.SET_UPDATE_PARSEDTREE_TEMPLATEFIELDS: {
      return {...state, updatedTemplateFieldsResponse: (action as types.ISetUpdateParsedTreeTemplateFields).updatedTemplateFieldsResponse};
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
